import { z } from 'zod';

export const webhookSchema = z.object({
  id: z.string(),
  url: z.string(),
  events: z.array(z.string()),
  isActive: z.boolean(),
  failureCount: z.number(),
  lastFailureAt: z.string().nullable().optional(),
  createdAt: z.string(),
  updatedAt: z.string(),
});
export type Webhook = z.infer<typeof webhookSchema>;

export const webhookInputSchema = z.object({
  url: z.string().url('Must be a valid URL'),
  secret: z.string().min(16, 'Secret must be at least 16 characters'),
  events: z.array(z.string()).min(1, 'At least one event is required'),
});
export type WebhookInput = z.infer<typeof webhookInputSchema>;
